import "./App.css";
import { Main } from "./components/Route/Main";

function App() {
  return (
    <div>
      <Main></Main>
    </div>
  );
}

export default App;
